import { render, staticRenderFns } from "./fvButton.vue?vue&type=template&id=bf5ba772&lang=pug&"
import script from "./fvButton.vue?vue&type=script&lang=js&"
export * from "./fvButton.vue?vue&type=script&lang=js&"
import style0 from "./fvButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvButton.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvButton.vue
// module id = 135
// module chunks = 0 1